import React from 'react';
import { extendTheme, ChakraProvider } from '@chakra-ui/react'
import { Switch } from 'react-router-dom'
import routes from './config/routes.js';
import { AuthProvider } from "./Context";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import NavbarComponent from "./Components/navbar.component";
import AppRoute from './Components/AppRoute';

const colors = {
    brand: {
        900: '#1a365d',
        800: '#153e75',
        700: '#2a69ac',
    },
}

const theme = extendTheme({ colors })

function App() {
    return (
        <>
            <ChakraProvider theme={theme}>
        <AuthProvider>
            <NavbarComponent />
                <Switch>
                    {routes.map((route) => (
                        <AppRoute
                            key={route.path}
                            path={route.path}
                            component={route.component}
                            isPrivate={route.isPrivate}
                        />
                    ))}
                </Switch>
        </AuthProvider></ChakraProvider></>
    );
}

export default App;
